import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/core/app-config/app-config.service';
import { DefaultPurchaseOrder } from '../models/default-purchase-order';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class LabConfigurationCommandService extends BaseService {

  appConfigService: AppConfigService;
  constructor(
    httpClient: HttpClient,
    appConfigService: AppConfigService) {
    super(httpClient, appConfigService.configuration.apiConfig.labConfigCommandBaseUrl);
    this.appConfigService = appConfigService;
  }


  addUpdateDefaultPurchaseOrder(accountCode: string, poNumber: string)
    : Observable<any> {
    const defaultPurchaseOrder: DefaultPurchaseOrder = {
      accountCode,
      poNumber
    };

    const apiUrl = `defaultPurchaseOrder`;
    return this.put<any>(apiUrl, defaultPurchaseOrder);
  }

  deleteDefaultPurchaseOrder<T>(accountCode: string): Observable<T> {
    const apiUrl = `accounts/${accountCode}/defaultPurchaseOrders`;
    return this.delete<T>(apiUrl);
  }
}
